__turbopack_context__.v({
  "heroBanner": "PublishEligibilityBanner-module__oG6VUa__heroBanner",
  "heroCoverImage": "PublishEligibilityBanner-module__oG6VUa__heroCoverImage",
  "heroTextContent": "PublishEligibilityBanner-module__oG6VUa__heroTextContent",
});
